import React from "react";
import PropTypes from "prop-types";
import Input from "app/pages/.shared/form/Input";
import { FormattedMessage } from "react-intl";
import { determineCardType, initAdyen } from "app/utils/creditCardUtils";
import PopoverButton from "app/pages/.shared/Popover/PopoverButton";
import { connect } from "react-redux";
import { paymentTypesValues } from "app/utils/propTypes";
import { CB_NUMBER_MAX_LENGTH, CREDIT_CARDS_TYPES, PAYMENT_METHODS } from "app/constants";

import "./CreditCardFieldset.scss";

class CreditCardFieldset extends React.PureComponent {
	constructor() {
		super();
		this.state = {
			cardType: undefined,
		};
		this.onHolderNameFocus = this.onHolderNameFocus.bind(this);
		this.onNumberFocus = this.onNumberFocus.bind(this);
		this.onCVCFocus = this.onCVCFocus.bind(this);
		this.onHolderNameFocus = this.onHolderNameFocus.bind(this);
		this.onAmountFocus = this.onAmountFocus.bind(this);
		this.updateCreditCardPicto = this.updateCreditCardPicto.bind(this);
	}

	onAmountFocus(event) {
		this.props.fields.amount.onFocus(event);
		if (this.props.onFocus) {
			this.props.onFocus();
		}
	}

	onHolderNameFocus(event) {
		this.props.fields.holderName.onFocus(event);
		if (this.props.onFocus) {
			this.props.onFocus();
		}
	}

	onNumberFocus(event) {
		this.props.fields.number.onFocus(event);
		if (this.props.onFocus) {
			this.props.onFocus();
		}
	}

	onCVCFocus(event) {
		this.props.fields.cvc.onFocus(event);
		if (this.props.onFocus) {
			this.props.onFocus();
		}
	}

	updateCreditCardPicto(event) {
		this.setState({
			cardType: determineCardType(event.target.value),
		});
		this.props.onCreditCardInformationChange(event);
	}

	componentDidMount() {
		initAdyen();
	}

	render() {
		const {
			fields = {
				holderName: {},
				number: {},
				expiryMonth: {},
				expiryYear: {},
				cvc: {},
				amount: {},
			},
			showAmountToPay,
			showAmountToPayNote,
			isAmountToPayRequired,
			selectedPaymentType,
			onBlur,
			onCreditCardInformationChange,
			isAmexAvailable,
		} = this.props;

		const { holderName, number, expiryMonth, expiryYear, cvc, amount } = fields;

		return (
			<div className="creditcard">
				{selectedPaymentType === PAYMENT_METHODS.CASINO && this.state.cardType === "amex" && (
					<div className="creditcard__note">
						<i className="icon icon--info" />
						<FormattedMessage
							id="error.payment.external.amex.not.supported.2"
							values={{ count: 4 }}
						/>
					</div>
				)}
				{showAmountToPay && (
					<div className="creditcard__item creditcard__item--amount">
						<Input
							type="tel"
							field={amount}
							onFocus={this.onAmountFocus}
							label={
								<span>
									<FormattedMessage id="creditcard.amount.label" />
									{isAmountToPayRequired ? "*" : ""}
								</span>
							}
							data-cy="creditcard-amount-input"
							name="creditcard-amount"
							id="creditcard-amount"
							onBlur={onBlur}
						/>
						{showAmountToPayNote && (
							<div className="creditcard__note">
								<FormattedMessage id="creditcard.amount.help.label" />
							</div>
						)}
					</div>
				)}
				<div className="creditcard__item creditcard__item--holdername">
					<Input
						data-cy="creditcard-holdername-input"
						field={holderName}
						onFocus={this.onHolderNameFocus}
						label={<FormattedMessage id="creditcard.holdername.label" />}
						name="creditcard-holdername"
						id="creditcard-holdername"
						onBlur={onBlur}
					/>
				</div>
				<div className="creditcard__item creditcard__item--number">
					<Input
						data-cy="creditcard-number-input"
						type="tel"
						data-field-name="number"
						field={number}
						onFocus={this.onNumberFocus}
						label={<FormattedMessage id="creditcard.number.label" />}
						name={
							selectedPaymentType === PAYMENT_METHODS.BCMC
								? "creditcard-bcmc-number"
								: "creditcard-number"
						}
						id={
							selectedPaymentType === PAYMENT_METHODS.BCMC
								? "creditcard-bcmc-number"
								: "creditcard-number"
						}
						maxLength={CB_NUMBER_MAX_LENGTH}
						onBlur={onBlur}
						onChange={this.updateCreditCardPicto}
					/>

					<div className="creditcard__type-picto">
						<i className={`icon icon--${this.state.cardType}-small`} />
					</div>
				</div>

				<div className="creditcard__item creditcard__item--expiration-month">
					<Input
						data-cy="creditcard-expmonth-input"
						type="tel"
						id="expiration-month"
						name="expiration-month"
						data-field-name="expiryMonth"
						field={expiryMonth}
						maxLength="2"
						label={<FormattedMessage id="creditcard.expiryMonth.label" />}
						onBlur={onBlur}
						onChange={onCreditCardInformationChange}
					/>
				</div>

				<div className="creditcard__item creditcard__item--expiration-year">
					<Input
						data-cy="creditcard-expyear-input"
						type="tel"
						id="expiration-year"
						name="expiration-year"
						data-field-name="expiryYear"
						field={expiryYear}
						maxLength="2"
						label={<FormattedMessage id="creditcard.expiryYear.label" />}
						onBlur={onBlur}
						onChange={onCreditCardInformationChange}
					/>
				</div>
				{selectedPaymentType !== PAYMENT_METHODS.BCMC && (
					<div className="creditcard__item creditcard__item--cvc">
						<Input
							data-cy="creditcard-cvc-input"
							type="tel"
							field={cvc}
							onFocus={this.onCVCFocus}
							label={
								<FormattedMessage
									id={
										this.state.cardType === CREDIT_CARDS_TYPES.MAESTRO
											? "creditcard.maestro.cvc.label"
											: "creditcard.cvc.label"
									}
								/>
							}
							name="creditcard-cvc"
							data-field-name="cvc"
							id="creditcard-cvc"
							onBlur={onBlur}
							onChange={onCreditCardInformationChange}
						/>

						<div className="creditcard__info-picto">
							<PopoverButton
								popOverClassName="creditcard__popover"
								popOverPosition="above"
								popOverContent={
									<div className="cvc-info">
										<div className="cvc-info__item">
											<FormattedMessage id="payment.cvc.text" />
										</div>
										<React.Fragment>
											{isAmexAvailable && (
												<div className="cvc-info__item">
													<FormattedMessage id="payment.cvc.amex.text" />
												</div>
											)}

											<div className="cvc-info__pictos">
												<i className="icon icon--cvc-cb" />
												{isAmexAvailable && (
													<i className="icon icon--cvc-amex" />
												)}
											</div>
										</React.Fragment>
									</div>
								}
								buttonLabel={<i className="icon icon--info-grey" />}
							/>
						</div>
					</div>
				)}
			</div>
		);
	}
}

CreditCardFieldset.propTypes = {
	fields: PropTypes.object,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	onCreditCardInformationChange: PropTypes.func,
	selectedPaymentType: PropTypes.oneOfType([paymentTypesValues]),
	showAmountToPay: PropTypes.bool,
	showAmountToPayNote: PropTypes.bool,
	isAmountToPayRequired: PropTypes.bool,
	isAmexAvailable: PropTypes.bool,
};

const mapStateToProps = state => {
	return {
		selectedPaymentType: state.booking.paymentType,
		selectedPaymentMode: state.booking.paymentMode,
		paymentTypes: state.payment.paymentTypes,
	};
};

export default connect(mapStateToProps)(CreditCardFieldset);
